import { useEffect, useState } from "react";
import { BadgePercent } from "lucide-react";
import { api } from "@/lib/api";
import OfferCard from "@/components/OfferCard";
import SectionHeader from "./SectionHeader";
import EmptyState from "./EmptyState";

export default function ActiveDeals() {
  const [offers, setOffers] = useState(null);

  useEffect(() => {
    api.get("/offers?sort=popular&limit=8").then((r) => setOffers(r.data || [])).catch(() => setOffers([]));
  }, []);

  if (offers === null) return null;

  return (
    <section className="bg-[#F2F4F5] border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14" data-testid="deals-section">
        <SectionHeader
          eyebrow="Bons plans"
          title="Les bons plans du moment"
          subtitle="Des réductions réelles négociées chez les commerçants d'Eure-et-Loir."
          linkTo="/bons-plans"
          linkLabel="Tous les bons plans"
          linkTestId="view-all-deals-btn"
        />

        {offers.length === 0 ? (
          <div className="mt-6">
            <EmptyState
              icon={BadgePercent}
              title="Aucun bon plan actif pour l'instant"
              text="Les premières offres locales arrivent très bientôt. Revenez vite ou invitez vos commerçants préférés à nous rejoindre !"
              ctaLabel="Recommander un commerce"
              ctaTo="/recommander-un-commerce"
              testId="deals-empty"
            />
          </div>
        ) : (
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 items-stretch">
            {offers.slice(0, 4).map((o) => (<OfferCard key={o.id} offer={o} />))}
          </div>
        )}
      </div>
    </section>
  );
}
